import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserCustomData } from '../../types/user';
import { FAQ } from '../../types/generic';
import { sanitiseString } from '../../utils/string';
import { ForceDetails } from '../../types/upload';

export interface SystemState extends UserCustomData {
	updateNoticeTitle?: string;
	updateNoticeDesc?: string | string[];
	faqs: FAQ[];
	forceDetails: ForceDetails;
	telemetryConfigured: boolean;
}

export const initialSystemState: SystemState = {
	touAgreed: false,
	theme: 'default',
	keyphrasesHelpViewed: false,
	faqs: [
		{
			question: "Why aren't there any FAQs here?",
			answer: `The system has not been set up correctly- please contact ${import.meta.env.VITE_CONTACT_EMAIL} and let us know!`,
			link: encodeURI(sanitiseString('No FAQs')),
		},
	],
	forceDetails: {
		Default: {
			forceAliases: ['police', 'police default'],
			useCases: { UNKNOWN_USE_CASE: { rrdDays: 0 } },
		},
	},
	telemetryConfigured: false,
};

const systemSlice = createSlice({
	name: 'system',
	initialState: initialSystemState,
	reducers: {
		initialSetup: (_, action: PayloadAction<SystemState>) => {
			return {
				touAgreed: action.payload.touAgreed,
				theme: action.payload.theme,
				keyphrasesHelpViewed: action.payload.keyphrasesHelpViewed,
				updateNoticeTitle: action.payload.updateNoticeTitle,
				updateNoticeDesc: action.payload.updateNoticeDesc,
				faqs: action.payload.faqs,
				forceDetails: action.payload.forceDetails,
				telemetryConfigured: false,
			};
		},
		updateUpdateNotice: (state, action: PayloadAction<{ title: string; desc: string[] }>) => {
			return {
				...state,
				updateNoticeTitle: action.payload.title,
				updateNoticeDesc: action.payload.desc,
			};
		},
		updateUserData: (state, action: PayloadAction<UserCustomData>) => {
			return {
				...state,
				...action.payload,
			};
		},
		registerTelemetryConfigured: (state) => {
			return {
				...state,
				telemetryConfigured: true,
			};
		},
	},
});

export const { initialSetup, updateUpdateNotice, updateUserData, registerTelemetryConfigured } = systemSlice.actions;
export default systemSlice.reducer;
